<template>
  <rest-list-action :icon="action.icon" :title="action.title" :click="click" />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
export default {
  name: 'RestListActionSetState',
  components: { RestListAction },
  inject: ['restList'],

  props: {
    endpoint: {
      type: Object,
      required: true
    },

    name: {
      type: String,
      required: false
    },

    rowState: {
      required: false
    },

    confirmationRequired: {
      type: Boolean,
      default: false
    },

    confirmationTitle: {
      type: String,
      default: 'Confirmation'
    },

    confirmationMessage: {
      type: String,
      default: ''
    },

    confirmationOkText: {
      type: String,
      default: 'Yes'
    },

    confirmationCancelText: {
      type: String,
      default: 'No'
    },
    reloadProjectConfig: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    click() {
      if (!this.confirmationRequired) {
        this.clickAction()
      } else {
        this.$msgbox({
          title: this.confirmationTitle,
          message: this.confirmationMessage,
          showCancelButton: true,
          confirmButtonText: this.confirmationOkText,
          cancelButtonText: this.confirmationCancelText,
          center: true
        }).then(() => {
          this.clickAction()
        })
      }
    },

    clickAction() {
      this.restList.loading = true

      let newState = !this.rowState

      this.$set(this.endpoint, 'data', {
        active: newState
      })

      RestApi(this.endpoint)
        .then(() => {
          if (newState) {
            this.$message({
              message: this.$t('RestList_ActivateSuccessMessage'),
              type: 'success'
            })
          } else {
            this.$message({
              message: this.$t('RestList_DeactivateSuccessMessage'),
              type: 'success'
            })
          }
          this.$emit('update:rowState', newState)
          if (this.reloadProjectConfig) {
            this.$store.dispatch('reloadProjectConfig')
          }
          this.restList.loading = false
        })
        .catch(error => {
          console.log(error)
          this.restList.loading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },

  computed: {
    action() {
      if (this.rowState) {
        return {
          icon: 'el-icon-check',
          title: this.$t('RestList_Deactivate')
        }
      } else {
        return {
          icon: 'el-icon-close',
          title: this.$t('RestList_Activate')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionSetState.vue